import { Form, Formik, FormikProps } from "formik";
import React, { useContext, useState } from "react";
import {
  PredefinedDataTypes,
  subsidiarySiteInputs,
} from "../../../../../../utils/formTypes";
import { subsidiarySiteValidation } from "../../../../../../utils/validationSchema";
import { useMutation } from "@apollo/client";
import {
  UpdateSubsidiarySiteResult,
  UpdateSubsidiarySitesVar,
} from "../queries/types";
import { UpdateSubsidiarySite } from "../queries/mutations";
import { EMPTY_STRING, emptyMessage } from "../../../../../../utils/constants";
import { Operation } from "../../../../../../utils/Enum.types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";

import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { AppContext } from "../../../../../../context/context";
import {
  addCountryCode,
  handleFormEvent,
  handleMUISelectEvent,
  removeMoreSpace,
} from "../../../../../../utils/UtilFunctions";
import { LabelProps } from "../../../../../../utils/types";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import InputNumber from "../../../../../common/Input/InputNumber";
import PredefinedAutocomplete from "../../../../../../customComponents/PredefinedAutocmplete";
import PhoneInput from "react-phone-input-2";
import { Keys } from "../../../../../../utils/Enum.keys";
import InputHoc from "../../../../../common/Input/Index";
import { Button } from "../../../../../../stories/Button/Button";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { Label } from "../../../../../../stories/Label/Label";
import LoadingModal from "../../../../../pages/LoadingModal";
import PredefinedSelect from "../../../../../../customComponents/PredefinedSelect";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";
import IconSelect from "../../../../../../customComponents/IconSelect";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const AssetSite = ({ setModalFlag }: Props) => {
  const [message, setMessage] = useState(emptyMessage);
  const { customer_id, sub_id } = useUrlParams();

  const { SubsidiarySites } = useFormJson();
  const { state } = useContext(AppContext);
  const { user_details } = useLoggedInUserDetails();
  const [edit, setEdit] = useState(false);

  const subsidiarySiteInitialValues: subsidiarySiteInputs = {
    name: "",
    address: "",
    place: "",
    state: "",
    pin: "",
    country: "",
    contactPerson: "",
    contactPersonDesign: "",
    contactPersonEmail: "",
    contactPersonMobile: "",
    email: "",
    mobile: "",
    latitude: "",
    longitude: "",
    gstNo: "",
    icon: "",
  };
  const [formData, setFormData] = useState<subsidiarySiteInputs>(
    subsidiarySiteInitialValues
  );
  const [UpdateSubDetails, { loading: UpdateSubsidiarySiteLoading }] =
    useMutation<UpdateSubsidiarySiteResult, UpdateSubsidiarySitesVar>(
      UpdateSubsidiarySite,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );
  const { subsidiarySiteLabel } = useLabels();
  const handleSubmit = async () => {
    try {
  
      if (customer_id && sub_id) {
        const customerUpdated = UpdateSubDetails({
          variables: {
     
            user_details,
            subsidiarySiteID: state.subSiteId,
            input: {
              name: removeMoreSpace(formData.address),
              address: removeMoreSpace(formData.address),
              place: removeMoreSpace(formData.place),
              email: formData.email,
              mobile: addCountryCode(formData.mobile),
              pin: formData.pin,
              state: formData.state,
              contactPerson: removeMoreSpace(formData.contactPerson),
              contactPersonDesign: formData.contactPersonDesign,
              contactPersonEmail: formData.contactPersonEmail,
              contactPersonMobile: addCountryCode(formData.contactPersonMobile),
              country: formData.country,
              latitude: Number(formData.latitude),
              longitude: Number(formData.longitude),
              isActive: "CURR",
              icon: formData.icon,
            },
          },
        });
        const { data } = await customerUpdated;

        if (data && data.UpdateSubsidiarySite) {
          setMessage({
            flag: true,
            message: `${subsidiarySiteLabel} Site updated successfully`,
            operation: Operation.CREATE,
          });
        }
        setEdit(false);
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };
  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<subsidiarySiteInputs>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };
  const handleNumberChange = (name: string, value: string) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const hanldeClear = () => {
    setFormData(subsidiarySiteInitialValues);
  };
  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      hanldeClear();
    }
  };
  const { companyLabel } = useLabels();
  return (
    <>
      <Formik
        initialValues={formData}
        validationSchema={subsidiarySiteValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form className="subsidary__view--form--company-details">
              <div className="subsidary__add--form-details">
                <div className="company-details__block--left">
                  <div className="company-details__block--details">
                    <h4>{companyLabel} Details</h4>
                  </div>
                  {SubsidiarySites.companyDetails.map(
                    (field: LabelProps, key: React.Key) => {
                      if (field.dataType === "textarea") {
                        return (
                          <>
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <TextArea
                                value={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLTextAreaElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                type={field.dataType}
                                rows={3}
                                name={field.inputName}
                                disabled={!edit}
                              />
                            </div>
                            {meta.touched && meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span></span>
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </>
                        );
                      } else if (field.dataType === "number") {
                        return (
                          <>
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <InputNumber
                                values={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                name={field.inputName}
                                required={field.required}
                                disabled={!edit}
                              />
                            </div>

                            {meta.touched && meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span></span>
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </>
                        );
                      } else if (field.dataType === "city") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <PredefinedSelect
                              label=""
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  place: e,
                                });
                              }}
                              type={PredefinedDataTypes.CITY}
                              value={formData.place as string}
                              name={field.inputName as string}
                            />
                          </div>
                        );
                      } else if (field.dataType === "state") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <PredefinedSelect
                              label=""
                              onChange={(e, state_code) => {
                                setFormData({
                                  ...formData,
                                  state: e,
                                  gstStateCode: state_code
                                    ? state_code
                                    : EMPTY_STRING,
                                });
                              }}
                              type={PredefinedDataTypes.STATE}
                              value={formData.state as string}
                              name={field.inputName as string}
                            />
                          </div>
                        );
                      } else if (field.dataType === "country") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <PredefinedSelect
                              label=""
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  country: e,
                                });
                              }}
                              type={PredefinedDataTypes.COUNTRY}
                              value={formData.country as string}
                              name={field.inputName as string}
                            />
                          </div>
                        );
                      } else if (field.dataType === "mobile") {
                        return (
                          <PhoneInput
                            country={"in"}
                            value={formData[field.inputName] as string}
                            onChange={(e: string) => {
                              handleNumberChange(field.inputName, e);
                            }}
                            inputProps={{
                              required: true,
                            }}
                            onKeyDown={(e) => {
                              if (e.key === Keys.ENTER) {
                                e.preventDefault();
                                handleMUISelectEvent(e);
                              }
                            }}
                            disabled={!edit}
                          />
                        );
                      } else if (field.dataType === "icon") {
                        return (
                          <IconSelect
                            onChange={(newValue) => {
                              if (newValue) {
                                setFormData({
                                  ...formData,
                                  icon: newValue.value as unknown as string,
                                });
                              } else {
                                setFormData({
                                  ...formData,
                                  icon: "",
                                });
                              }
                            }}
                          />
                        );
                      } else {
                        return (
                          <React.Fragment key={key}>
                            <InputHoc
                              LabelName={field.labelName}
                              values={formData[field.inputName]}
                              name={field.inputName}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleValueChange(e, meta);
                              }}
                              required={field.required}
                              autoFocus={field.autoFocus}
                              disabled={!edit}
                            />

                            {meta.touched && meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span></span>
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </React.Fragment>
                        );
                      }
                    }
                  )}
                </div>
                <div className="company-details__block--right">
                  <div className="company-details__block--details">
                    <h4>Contact Details</h4>
                  </div>
                  {SubsidiarySites.contactDetails.map(
                    (field: LabelProps, key: React.Key) => {
                      if (field.dataType === "textarea") {
                        return (
                          <>
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <TextArea
                                value={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLTextAreaElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                type={field.dataType}
                                rows={3}
                                name={field.inputName}
                                disabled={!edit}
                              />
                            </div>

                            {meta.touched && meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span></span>
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </>
                        );
                      } else if (field.dataType === "number") {
                        return (
                          <>
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <InputNumber
                                values={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                name={field.inputName}
                                required={field.required}
                                disabled={!edit}
                              />
                            </div>
                            {meta.touched && meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span></span>
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </>
                        );
                      } else if (field.dataType === "city") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <InputNumber
                              value={formData[field.inputName]}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleValueChange(e, meta);
                              }}
                              onKeyDown={handleFormEvent}
                              name={field.inputName}
                              required={field.required}
                              maxLength={field.maxLength}
                            />
                          </div>
                        );
                      } else if (field.dataType === "state") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <PredefinedSelect
                              label=""
                              onChange={(e, state_code) => {
                                setFormData({
                                  ...formData,
                                  state: e,
                                  gstStateCode: state_code
                                    ? state_code
                                    : EMPTY_STRING,
                                });
                              }}
                              type={PredefinedDataTypes.STATE}
                              value={formData.state as string}
                              name={field.inputName as string}
                            />
                          </div>
                        );
                      } else if (field.dataType === "country") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <PredefinedSelect
                              label=""
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  country: e,
                                });
                              }}
                              type={PredefinedDataTypes.COUNTRY}
                              value={formData.country as string}
                              name={field.inputName as string}
                            />
                          </div>
                        );
                      } else if (field.dataType === "mobile") {
                        return (
                          <>
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                inputProps={{
                                  required: true,
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                                disabled={!edit}
                              />
                            </div>
                          </>
                        );
                      } else {
                        return (
                          <React.Fragment key={key}>
                            <InputHoc
                              LabelName={field.labelName}
                              values={formData[field.inputName]}
                              name={field.inputName}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleValueChange(e, meta);
                              }}
                              required={field.required}
                              autoFocus={field.autoFocus}
                              disabled={!edit}
                            />
                            {meta.touched && meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span></span>
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </React.Fragment>
                        );
                      }
                    }
                  )}
                </div>
              </div>
              {!edit ? (
                <Button
                  mode="edit"
                  type="button"
                  onClick={() => setEdit(true)}
                />
              ) : (
                <Button mode="save" type="submit" />
              )}
              <Button mode="clear" type="button" onClick={hanldeClear} />

              <Button mode="cancel" onClick={() => setModalFlag(false)} />
              <MessageModal
                handleClose={handleClose}
                modalFlag={message.flag}
                operation={message.operation}
                value={message.message}
              />
            </Form>
          );
        }}
      </Formik>
      <LoadingModal flag={UpdateSubsidiarySiteLoading} />
    </>
  );
};

export default AssetSite;
